import Icon from '../components/Icon.vue'

Icon.register({
  'swimming-pool': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 416H608C582 416 562.2 407.6 551.9 398.1 543 389.9 532.3 384 520.1 384H503.8C491.7 384 481 389.9 472.1 398.1 461.8 407.6 442 416 416 416S370.2 407.6 359.9 398.1C351 389.9 340.3 384 328.1 384H311.8C299.7 384 289 389.9 280.1 398.1 269.8 407.6 250 416 224 416S178.2 407.6 167.9 398.1C159 389.9 148.3 384 136.1 384H119.8C107.7 384 97 389.9 88.1 398.1 77.8 407.6 58 416 32 416H16C7.2 416 0 423.2 0 432V464C0 472.8 7.2 480 16 480H32C70.6 480 104.7 467.8 128 448.2 151.3 467.8 185.4 480 224 480S296.7 467.8 320 448.2C343.3 467.8 377.4 480 416 480S488.7 467.8 512 448.2C535.3 467.8 569.4 480 608 480H624C632.8 480 640 472.8 640 464V432C640 423.2 632.8 416 624 416zM224 384V288H416V384C435.1 384 446.9 377.8 450.4 374.6 459.6 366.1 469.6 360.2 480 356.5V128C480 110.4 494.4 96 512 96S544 110.4 544 128V144C544 152.8 551.2 160 560 160H592C600.8 160 608 152.8 608 144V128C608 75.1 564.9 32 512 32S416 75.1 416 128V224H224V128C224 110.4 238.4 96 256 96S288 110.4 288 128V144C288 152.8 295.2 160 304 160H336C344.8 160 352 152.8 352 144V128C352 75.1 308.9 32 256 32S160 75.1 160 128V356.5C170.4 360.2 180.4 366.1 189.6 374.6 193.1 377.8 204.9 384 224 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/swimming-pool.js
// module id = i+4g
// module chunks = 144